import React from "react";
import AnimatedContent from "./AnimatedContent";
import PopUp from "./PopUp";
import useWindowSize from "../../utils/hooks/useWindowSize";

const Section = (props) => {
  const windowSize = useWindowSize();
  const isMobileView = windowSize.x < 950;

  const isMobileLandscape = windowSize.x > windowSize.y && windowSize.x <= 915;

  console.log("isMobileLandscape", isMobileLandscape);

  if (isMobileLandscape) {
    return (
      <>
        <div
          className="section-container"
          style={{
            backgroundColor: props?.reverse ? "#000000" : "transparent",
            flexDirection: props?.reverse ? "row-reverse" : "row"
          }}>
          <div className="section-content">
            <AnimatedContent side={props?.reverse ? "right" : "left"}>
              <h3
                className="title"
                style={{
                  textAlign: props.reverse ? "right" : "left"
                }}>
                {props.title}
              </h3>
            </AnimatedContent>
            <AnimatedContent side={props?.reverse ? "right" : "left"}>
              <p
                className="subtitle"
                style={{
                  textAlign: props.reverse ? "right" : "left"
                }}>
                {props.subtitle}
              </p>
            </AnimatedContent>
          </div>
          <PopUp>
            <div style={{ perspective: "1000px" }}>
              <img
                style={{
                  height: 400,
                  boxSizing: "border-box",
                  position: "relative",
                  transform: `rotateY(${props.reverse ? 25 : -25}deg) rotateX(15deg)`
                }}
                src={props.appImage}
                alt="app"
              />
            </div>
          </PopUp>
        </div>
      </>
    );
  }

  return (
    <>
      <div
        className="section-container"
        style={{
          backgroundColor: props?.reverse ? "#000000" : "transparent",
          flexDirection: isMobileView ? "column" : props?.reverse ? "row-reverse" : "row"
        }}>
        {isMobileView && (
          <div style={{ position: "relative", top: 20 }}>
            <AnimatedContent side={props?.reverse ? "right" : "left"}>
              <h3
                className="title"
                style={{
                  textAlign: "center"
                }}>
                {props.title}
              </h3>
            </AnimatedContent>
          </div>
        )}
        {!isMobileView && (
          <div className="section-content">
            <AnimatedContent side={props?.reverse ? "right" : "left"}>
              <h3
                className="title"
                style={{
                  textAlign: props.reverse ? "right" : "left"
                }}>
                {props.title}
              </h3>
            </AnimatedContent>
            <AnimatedContent side={props?.reverse ? "right" : "left"}>
              <p
                className="subtitle"
                style={{
                  textAlign: props.reverse ? "right" : "left"
                }}>
                {props.subtitle}
              </p>
            </AnimatedContent>
          </div>
        )}
        {isMobileView && (
          <div
            style={{
              display: "flex",
              flexDirection: props?.reverse ? "row-reverse" : "row",
              alignItems: "center",
              margin: props?.reverse ? "0 25px 0 0" : "0 0 0 25px"
            }}>
            <AnimatedContent side={props?.reverse ? "right" : "left"}>
              <p
                className="subtitle"
                style={{
                  textAlign: props.reverse ? "right" : "left"
                }}>
                {props.subtitle}
              </p>
            </AnimatedContent>
            <PopUp>
              <div style={{ display: "flex", justifyContent: "center", perspective: "1000px" }}>
                <img
                  style={{
                    height: 400,
                    boxSizing: "border-box",
                    position: "relative",
                    transform: `rotateY(${props.reverse ? 25 : -25}deg) rotateX(15deg)`
                  }}
                  src={props.appImage}
                  alt="app"
                />
              </div>
            </PopUp>
          </div>
        )}
        {!isMobileView && (
          <PopUp>
            <div style={{ perspective: "1000px" }}>
              <img
                style={{
                  height: "812px",
                  boxSizing: "border-box",
                  position: "relative",
                  top: "-51px",
                  transform: `rotateY(${props.reverse ? 25 : -25}deg) rotateX(15deg)`
                }}
                src={props.appImage}
                alt="app"
              />
            </div>
          </PopUp>
        )}
      </div>
    </>
  );
};

export default Section;
